import URI from 'urijs'
import activityPath from './activity_path'

export default (activityState) => {
  const ret = {
    path: null,
    track: true
  }

  const activity = activityState.get('activity')

  if (activity) {
    if (activityPath(activity)) {
      ret.path = activityPath(activity)

      if (activityState.get('pageAction')) {
        ret.path = URI(ret.path)
          .segment(activityState.get('pageAction'))
          .toString()
      }
    } else {
      // If this model does not have the necessary data to construct a url, then
      // don't generate a url
      return false
    }
  } else if (activityState.get('page') === 'search') {
    const uri = URI('activities').segment('search')

    if (activityState.get('searchTerm')) {
      uri.query({ term: activityState.get('searchTerm') })
    }

    ret.path = uri.toString()

    // Only track if we are hitting this page for the first time.
    // Otherwise just replace
    const prevPage = activityState.previous('page')
    ret.track = prevPage !== 'search'
  } else if (activityState.get('page') === 'group') {
    const group = activityState.get('group')
    // Don't track if our group doesn't have an id yet
    if (!group.has('id')) {
      return false
    }

    ret.path = `activities?group_id=${group.id}`
  } else if (activityState.get('page') === 'trash') {
    ret.path = URI('activities').segment('trash').toString()
  } else if (activityState.get('page') === 'activities') {
    ret.path = '/activities'
  }

  return ret
}
